
<template>
  <div class="animated fadeIn">
    <div class="row dashboard-first-row">
      <div class="col-12 col-lg-4">
        <div class="row">
          <div class="col-md-12">
            <b-row>
              <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                  <div slot="header" class="text-white">
                    <i class="fas fa-search mr-2"></i>Find/Start A New Quote
                  </div>
                  <b-card-body class="ml-2 mr-2">
                    <b-row>
                      <b-col class="px-0">
                        <!-- CONFIRM & CONSENT NOTICE -->
                                        <div class="d-flex justify-content-center mx-auto my-3 w-100">
                                          <div class="alert alert-warning  w-100" role="note">
                                            <div class="row no-gutters">
                                              <div class="d-inline-block pr-2">
                                                <img width="20px" height="20px" src="../../../assets/exclamation-circle-yellow-new.svg" alt="info">
                                              </div>
                                              <div class="col d-inline-block my-auto smaller-font-content">
                                                <p class="mb-0 text-dark-gray"><strong>Prior to gathering information from the customer, please read the following statement:</strong> <br>"I’ll be submitting your information to insurance carriers I represent who will provide you with a notice describing their privacy policies and practices once an insurance policy has been established."</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                        <b-form-group>
                          <label for="emailorPhone">Email or Phone Number</label>
                          <b-form-input
                          ref="emailorPhone"
                          name="emailorPhone"
                          type="text"
                          class="col-md-10"
                          id="emailorPhone"
                          v-model.trim="formData.ep"
                          placeholder="Email Address/ Phone Number"
                          ></b-form-input>
                          <div v-show="errors.has('emailorPhone')" class="text-danger">
                            {{ errors.first('emailorPhone') }}
                            </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="px-0">
                        <b-form-group>
                          <input-product-type :insuranceType="insuranceType"></input-product-type>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="px-0">
                        <b-form-group>
                          <label for="zipcode">Zip Code<span class="star">*</span></label>
                          <div class="input-group" style="width:35%;max-width:100%">
                            <input
                            name="zipcode"
                            id="zipcode"
                            type="text"
                            ref="zipcode"
                            v-validate="'digits:5'"
                            v-model="formData.zip" maxlength="5"
                            v-mask="'#####'"
                            size="5"
                            class="std-width form-control"
                            v-bind:class="{'form-control': true, 'error': errors.has('zipcode') }">
                            <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('zipcode') }"></span>
                          </div>
                          <div v-show="errors.has('zipcode')" class="text-danger">
                              {{ errors.first('zipcode') }}
                          </div>
                          <div class="mt-1">
                          <span class="qrp-text-muted">(<span class="star">*</span>Required for new quotes.)</span>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <div v-if="errorMessage" class="col-12 mb-2 px-0 text-notice error-red">
                        <span><strong>Required:</strong> {{ errorMessage }}</span>
                      </div>
                    </b-row>
                    <b-row>
                      <b-col class="px-0">
                        <b-button type="submit" variant="btn btn-primary" @click="searchResult" class="mb-2">Find Quote</b-button>
                        <b-button type="button" variant="btn btn-outline-primary" @click="newQuote" class="mb-2">New Quote</b-button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8">
        <b-card :class="widgetClasses(recentQuotesReportInfo)">
          <dashboard-widget
          :widgetType="'list'"
          :widgetData="recentQuotesReport"
          :widgetInfo="recentQuotesReportInfo"
          :chartDateFiltersPrimary="recentQuotesDateFilters">
          </dashboard-widget>
        </b-card>
      </div>
    </div>
    <div class="row dashboard-second-row">
      <div class="col-12 col-lg-6">
        <!--Sales by State-->
        <b-card :class="widgetClasses(stateReportInfo)">
          <dashboard-widget
          :widgetType="'report'"
          :widgetData="stateReport"
          :widgetInfo="stateReportInfo"
          :chartDateFiltersPrimary="stateDateFilters"
          :productFilters="stateProductFilters">
          </dashboard-widget>
        </b-card>
      </div>

      <div class="col-12 col-lg-6">
        <!--Sales by Agent-->
        <b-card :class="widgetClasses(agentReportInfo)">
          <dashboard-widget
          :widgetType="'report'"
          :widgetData="agentReport"
          :widgetInfo="agentReportInfo"
          :chartDateFiltersPrimary="agentDateFilters"
          :productFilters="agentProductFilters">
          </dashboard-widget>
        </b-card>
      </div>
    </div>
    <div class="row dashboard-third-row">
      <div class="col-12 col-lg-6">
        <!--Quotes by Carrier-->
        <b-card :class="widgetClasses(carrierReportInfo)">
          <dashboard-widget
          :widgetType="'chart'"
          :widgetData="carrierReport"
          :widgetInfo="carrierReportInfo"
          :chartDateFiltersPrimary="carrierDateFilters"
          :productFilters="carrierProductFilters">
          </dashboard-widget>
        </b-card>
      </div>

      <div class="col-12 col-lg-6">
        <!--Sales by Carrier-->
        <b-card :class="widgetClasses(carrierSalesReportInfo)">
          <dashboard-widget
          :widgetType="'chart'"
          :widgetData="carrierSalesReport"
          :widgetInfo="carrierSalesReportInfo"
          :chartDateFiltersPrimary="carrierSalesDateFilters"
          :productFilters="carrierSalesProductFilters">
          </dashboard-widget>
        </b-card>
      </div>

      <div class="col-12 col-lg-6">
        <!--Sales by Product-->
        <b-card :class="widgetClasses(productSalesReportInfo)">
          <dashboard-widget
          :widgetType="'chart'"
          :widgetData="productSalesReport"
          :widgetInfo="productSalesReportInfo"
          :chartDateFiltersPrimary="productSalesDateFilters">
          </dashboard-widget>
        </b-card>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import DateRangeFilter from '@/services/DateRangeFilter';
import ProductFilter from '@/services/ProductFilter';
import User from '@/services/User';
import InputProductType from '../../interactive/InputProductType';
import DashboardWidget from '../../presentational/widgets/DashboardWidget';
import ReportRequest from '../../../services/ReportRequest';
import filters from '../../../../config/admin/filters';
import QRP from '../../../../config/QRP.env';
import { quoteMixin } from '../../../mixins/quoteMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  mixins: [quoteMixin],
  name: 'dashboard',
  components: {
    DashboardWidget,
    DateRangeFilter,
    InputProductType,
  },
  data() {
    return {
      stateProductFilters: null,
      agentProductFilters: null,
      carrierProductFilters: null,
      carrierSalesProductFilters: null,
      stateDateFilters: null,
      agentDateFilters: null,
      carrierDateFilters: null,
      carrierSalesDateFilters: null,
      recentQuotesDateFilters: null,
      recentSalesDateFilters: null,
      productSalesDateFilters: null,
      stateReportInfo: {
        widgetTitle: 'Sales by State',
        widgetName: 'sales-by-state',
      },
      agentReportInfo: {
        widgetTitle: 'Sales by Agent',
        widgetName: 'sales-by-agent',
      },
      carrierReportInfo: {
        widgetTitle: 'Rate Call Success by Carrier',
        xAxis: 'CustomerCount',
        yAxis: 'CarrierName',
        widgetName: 'quotes-by-carrier',
      },
      productSalesReportInfo: {
        widgetTitle: 'Sales By Product',
        xAxis: 'PolicyCount',
        yAxis: 'ProductName',
        widgetName: 'sales-by-product',
      },
      carrierSalesReportInfo: {
        widgetTitle: 'Sales by Carrier',
        xAxis: 'PolicyCount',
        yAxis: 'CarrierName',
        widgetName: 'sales-by-carrier',
      },
      recentQuotesReportInfo: {
        widgetTitle: 'My Recent Quotes',
        linkTitle: 'Quote Search',
        route: 'search',
        widgetName: 'recent-quotes',
      },
      stateReport: null,
      agentReport: null,
      carrierReport: null,
      carrierSalesReport: null,
      productSalesReport: null,
      recentQuotesReport: null,
      recentSalesReport: null,
      masked_input: '',
      errorMessage: '',
      formData: {
        fname: '',
        lname: '',
        zip: '',
        dob: '',
        ep: '',
        productType: '',
      },
      items: [],
      selected: 'Month',
      productButtonsData: {},
      insuranceType: {
        field_name: 'insurance_type',
        field_value: '',
        label: 'Product',
        rules: [],
        field_type: 'text',
        help_text: '',
        values: [],
        is_required: true,
        is_enabled: true,
        visible: true,
        placeholder: null,
        sub_text: null,
        multi_select: false,
      },
    };
  },
  created() {
    // TODO: Abstract into factory.

    /**
     * Product filters per widget
     */
    this.stateProductFilters = new ProductFilter('stateProductFilters', filters.products);
    this.stateProductFilters.placeholder = 'All Products';
    this.stateProductFilters.field_value = sessionStorage.getItem(this.stateProductFilters.field_name) || filters.productDefault;

    this.agentProductFilters = new ProductFilter('agentProductFilters', filters.products);
    this.agentProductFilters.placeholder = 'All Products';
    this.agentProductFilters.field_value = sessionStorage.getItem(this.agentProductFilters.field_name) || filters.productDefault;

    this.carrierProductFilters = new ProductFilter('carrierProductFilters', filters.products);
    this.carrierProductFilters.placeholder = 'All Products';
    this.carrierProductFilters.field_value = sessionStorage.getItem(this.carrierProductFilters.field_name) || filters.productDefault;

    this.carrierSalesProductFilters = new ProductFilter('carrierSalesProductFilters', filters.products);
    this.carrierSalesProductFilters.placeholder = 'All Products';
    this.carrierSalesProductFilters.field_value = sessionStorage.getItem(this.carrierSalesProductFilters.field_name) || filters.productDefault;

    /**
     * Date filters per widget
     */
    this.stateDateFilters = new DateRangeFilter('stateDateFilters', filters.dateRangeMinimal);
    this.stateDateFilters.field_value = sessionStorage.getItem(this.stateDateFilters.field_name) || filters.dateFilterDefaults.dashboardWidgets.stateDateFilters;

    this.agentDateFilters = new DateRangeFilter('agentDateFilters', filters.dateRangeMinimal);
    this.agentDateFilters.field_value = sessionStorage.getItem(this.agentDateFilters.field_name) || filters.dateFilterDefaults.dashboardWidgets.agentDateFilters;

    this.carrierDateFilters = new DateRangeFilter('carrierDateFilters', filters.dateRangeMinimal);
    this.carrierDateFilters.field_value = sessionStorage.getItem(this.carrierDateFilters.field_name) || filters.dateFilterDefaults.dashboardWidgets.carrierDateFilters;

    this.carrierSalesDateFilters = new DateRangeFilter('carrierSalesDateFilters', filters.dateRangeMinimal);
    this.carrierSalesDateFilters.field_value = sessionStorage.getItem(this.carrierSalesDateFilters.field_name) || filters.dateFilterDefaults.dashboardWidgets.carrierSalesDateFilters;

    this.productSalesDateFilters = new DateRangeFilter('productSalesDateFilters', filters.dateRangeMinimal);
    this.productSalesDateFilters.field_value = sessionStorage.getItem(this.productSalesDateFilters.field_name) || filters.dateFilterDefaults.dashboardWidgets.productSalesDateFilters;

    this.recentQuotesDateFilters = new DateRangeFilter('recentQuotesDateFilters', {});

    this.recentSalesDateFilters = new DateRangeFilter('recentSalesDateFilters', {});

    this.stateReport = new ReportRequest();
    this.stateReport.reportType = 'SalesByState';
    this.stateReport.dateRange = this.stateDateFilters.field_value;
    this.stateReport.product = this.stateProductFilters.field_value;
    this.stateReport.productId = this.stateProductFilters.field_value;
    this.stateReport.dimensions.push('State'); // Only add primary dimension
    this.stateReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.agentReport = new ReportRequest();
    this.agentReport.reportType = 'SalesByAgent';
    this.agentReport.dateRange = this.agentDateFilters.field_value;
    this.agentReport.product = this.agentProductFilters.field_value;
    this.agentReport.productId = this.agentProductFilters.field_value;
    this.agentReport.dimensions.push('Agent'); // Only add primary dimension
    this.agentReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.carrierReport = new ReportRequest();
    this.carrierReport.reportType = 'QuotesByCarrier';
    this.carrierReport.dateRange = this.carrierDateFilters.field_value;
    this.carrierReport.product = this.carrierProductFilters.field_value;
    this.carrierReport.productId = this.carrierProductFilters.field_value;
    this.carrierReport.dimensions.push('Carrier'); // Only add primary dimension
    this.carrierReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.carrierSalesReport = new ReportRequest();
    this.carrierSalesReport.reportType = 'SalesByCarrier';
    this.carrierSalesReport.dateRange = this.carrierSalesDateFilters.field_value;
    this.carrierSalesReport.product = this.carrierSalesProductFilters.field_value;
    this.carrierSalesReport.productId = this.carrierSalesProductFilters.field_value;
    this.carrierSalesReport.dimensions.push('Carrier'); // Only add primary dimension
    this.carrierSalesReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.productSalesReport = new ReportRequest();
    this.productSalesReport.reportType = 'SalesByProduct';
    this.productSalesReport.dateRange = this.productSalesDateFilters.field_value;
    this.productSalesReport.dimensions.push('Product'); // Only add primary dimension
    this.productSalesReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.recentQuotesReport = new ReportRequest();
    this.recentQuotesReport.reportType = 'RecentQuotes';
    this.recentQuotesReport.dateRange = 'Recent';
    this.recentQuotesReport.filters = {teams: [], agents: [], carriers: [], states: []};

    this.recentSalesReport = new ReportRequest();
    this.recentSalesReport.reportType = 'RecentSales';
    this.recentSalesReport.dateRange = 'Recent';
    this.recentSalesReport.filters = {teams: [], agents: [], carriers: [], states: []};
  },
  mounted() {
    User.init().then((res) => {
      this.productButtonsData = Object.create(this.insuranceType);
      const productOrder = [1, 21, 18, 12, QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
      
      if(res.productAccess.includes(QRP.PRODUCTS.AUTO) && res.productAccess.includes(QRP.PRODUCTS.HOME)) {
        res.productAccess.push(QRP.PRODUCTS.HA_BUNDLE);
      }
      if(res.productAccess.includes(QRP.PRODUCTS.CONDO) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.CA_BUNDLE);
      }
      if(res.productAccess.includes(QRP.PRODUCTS.RENTERS) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.RA_BUNDLE);
      }

      if (typeof res.productAccess === 'object') {
        for (let i = 0; i < productOrder.length; i += 1) {
          if (res.productAccess.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      } else {
        const productAccessArray = res.productAccess.split(',');

        for (let i = 0; i < productOrder.length; i += 1) {
          if (productAccessArray.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      }

      if (res.productAccess.length === 1) {
        this.productButtonsData.field_value = res.productAccess[0]; // the single product is set as the selected one
      }

      this.insuranceType = [];
      this.insuranceType = this.productButtonsData;
    });
    // this.$refs.emailorPhone.focus();
  },
  methods: {
    /**
     * add switch on/off effect to product type
     */
    setProductType(oValue, nValue) {
      if (oValue === nValue) {
        this.insuranceType.field_value = '';
      } else {
        this.insuranceType.field_value = nValue;
      }
    },
    widgetClasses(widgetInfo) {
      return `${widgetInfo.widgetName} no-padding`;
    },
    /**
     * Redirect to search page with field prefilled from phone and email
     */
    newQuote() {
      this.errorMessage = '';
      this.newQuoteSubmit();
      // this.$router.push({ path: '/search', query: { action: 'newQuote', ep: this.formData.ep, pt: this.insuranceType.field_value, zip: this.formData.zip } });
    },
    /**
     * To redirect user to search page with entered parameters to display result
     */
    searchResult() {
      /* eslint arrow-parens: [0] */
      const that = this;
      this.$validator.detach('emailorPhone');
      this.$validator.detach('zipcode');
      this.$validator.detach(this.insuranceType.field_name);

      this.$validator.attach({
        name: 'zipcode',
        rules: 'digits:5',
        getter: () => that.formData.zip,
      });
      // this.$validator.attach({
      //   name: this.insuranceType.field_name,
      //   rules: 'required',
      //   getter: () => this.insuranceType.field_value,
      // });
      if (this.formData.ep !== '') { // if email or phone field is entered then validate email or phone.
        if (this.formData.ep.indexOf('@') !== -1) {
          this.$validator.attach({
            name: 'emailorPhone',
            rules: 'email',
            getter: () => that.formData.ep,
          });
        } else {
          this.$validator.attach({
            name: 'emailorPhone',
            rules: { regex: /^(\d{3})-?(\d{3})-?(\d{4})$/ },
            getter: () => that.formData.ep,
          });
        }
      }
      this.$validator.validateAll().then(result => {
        let submissionValidationRulesPass = false;
        // All form elements must be valid before submission validation is tested against
        if (!result) {
          that.errorMessage = '';
          return;
        }
        // this.formData.productType = this.insuranceType.field_value;
        // Scenario 4)
        if (that.formData.ep) {
          submissionValidationRulesPass = true;
        } else {
          /* eslint no-lonely-if:  */
          // Error Message Scenario A)
          if (that.formData.ep === '') {
            that.errorMessage = 'Enter Email Address or Phone Number.';
          } else {
            // No error message scenarios are true
            that.errorMessage = '';
          }
        }

        if (submissionValidationRulesPass) {
          if (this.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.HOME;
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.CONDO;
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.RENTERS;
          } else {
            this.formData.productType = this.insuranceType.field_value !== '' ? this.insuranceType.field_value : 0;
          }
          that.errorMessage = '';
          this.$store.dispatch('setSearchResultParams', this.formData);
          this.$router.push('/search');
        }
      });
    },
    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    flag(value) {
      return `flag-icon flag-icon- ${value}`;
    },
  },
  computed: {
    /**
     * Uses data property `masked_input` to store the input field's value without masked characters
     * added. A separate property needs to be used otherwise the computed property would keep updating
     * itself and end up in an infinite loop!
     */
    /* eslint object-shorthand:  */
    /* eslint func-names: [0] */
    masked_input_value: {
      get: function () {
        return this.masked_input;
      },
      set: function (newValue) {
        this.masked_input = newValue;
        this.formData.phone = this.masked_input;
      },
    },
  },
};
</script>

<style>
  .dashboard-first-row {
    .qrp-text-muted {
      font-size: 0.625rem;
      display: block;
      margin-bottom: 0.625rem;
    }
  }
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .card-header{
    padding: 0.5rem 1.25rem;
    background-color: #00162B;
    border-bottom: none;
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0 !important;
  }

/**WIDGET STYLING**/
.card.no-padding,
.card.no-padding .card-body {
  padding: 0 !important;
}

/**WIDGET DATATABLE STYLING**/
.dashboard-widget table.report-table {
  margin-bottom: 0;
}
.dashboard-widget .report-table tr:last-child {
  border-bottom:1px solid #c8ced3;
}
/**BREAKPOINT: WIDGET DATATABLE DISPLAY OVERRIDES**/
@media (max-width: 992px) {
  .dashboard-widget table.report-table {
    display: table !important;
  }
  .dashboard-widget .card-header {
    min-height: auto;
  }
}

  .dashboard-widget .report-table th {
    color: #121212;
    font-weight: 600;
    padding: 0.5rem 0.75rem;
    cursor: default;
  }
    .dashboard-widget .report-table th::after {
      content: none;
    }

.dashboard-widget .report-table.table-sm td {
  padding: 0.5rem 0.75rem !important;
  text-align: left !important;
}
  .dashboard-widget .report-table.table-sm td div {
    padding: 0;
  }

  .dashboard-widget .report-table th:nth-child(1),
  .dashboard-widget .report-table td:nth-child(1) {
    min-width: auto !important;
    max-width: none !important;
    width: auto;
    text-align: left;
    white-space: nowrap;
    border-right: 1px solid #cccccc;
    border-left: none;
  }
  .dashboard-widget .report-table th:nth-child(2), .dashboard-widget .report-table td:nth-child(2) {
    border-left: 1px solid #cccccc;
  }
  .dashboard-widget .report-table th:last-child, .dashboard-widget .report-table td:last-child {
    border-right: none;
  }
  /**Date Column Fixed Width**/
  .card.recent-quotes .dashboard-widget .report-table th:nth-child(1),
  .card.recent-quotes .dashboard-widget .report-table td:nth-child(1),
  .card.recent-sales .dashboard-widget .report-table th:nth-child(1),
  .card.recent-sales .dashboard-widget .report-table td:nth-child(1) {
    width: 75px;
  }
  /**Phone Column Fixed Width**/
  .card.recent-quotes .dashboard-widget .report-table th:nth-child(4),
  .card.recent-quotes .dashboard-widget .report-table td:nth-child(4) {
    min-width: 115px;
  }

  /**Widgets: Datatable Row Icons**/
  .card.sales-by-state .report-table tbody tr td:first-child div::before,
  .card.sales-by-agent .report-table tbody tr td:first-child div::before {
    margin-right: 0.25rem;
    font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
    font-weight: 600;
    color: #3674B2;
  }
    .card.sales-by-state .report-table tbody tr td:first-child div::before {
      content: "\f3c5";
    }
    .card.sales-by-agent .report-table tbody tr td:first-child div::before {
      content: "\f590";
    }

  /**Widgets: Datatable Typography**/
  .card.recent-quotes .report-table tbody tr td:nth-child(2),
  .card.recent-sales .report-table tbody tr td:nth-child(2),
  .card.sales-by-agent .report-table tbody tr td:first-child {
    text-transform: capitalize;
  }
@media (min-width: 992px) {
  .card-header {
    min-height: 71px;
  }
  .recent-quotes.card {
    min-height: 362px;
  }
  .dashboard-first-row .card-header {
    min-height: auto;
  }
}
@media (min-width: 1094px) {
  .recent-quotes.card {
    min-height: 275px;
  }
}
@media (min-width: 1332px) {
  .card-header {
    min-height: auto;
  }
  .sales-by-product .card-header {
    min-height: 71px;
  }
}
@media (min-width: 1881px) {
  .sales-by-product .card-header {
    min-height: auto;
  }
}
#stateProductFilters:focus, #stateDateFilters:focus, #agentProductFilters:focus, #agentDateFilters:focus,
#carrierProductFilters:focus, #carrierDateFilters:focus, #carrierSalesProductFilters:focus, #carrierSalesDateFilters:focus,
#productSalesDateFilters:focus {
  box-shadow: 0 0 0 0.2rem rgb(255 255 255 / 50%) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/dashboard/Dashboard.vue?ffe0a072